/**
 * Set the header to its "thin" state after
 * scrolling a certain amount
 *
 * @returns {*}
 */
function sizeTheHeader () {
    const $header = $('header');
    if ($(window).scrollTop() > $header.outerHeight()) {
        return $header.addClass('thin');
    }
    $header.removeClass('thin');
}

$(window).scroll(sizeTheHeader);